import { render, staticRenderFns } from "./SettingsContainer.vue?vue&type=template&id=657ba001&scoped=true&"
import script from "./SettingsContainer.vue?vue&type=script&lang=js&"
export * from "./SettingsContainer.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContainer.vue?vue&type=style&index=0&id=657ba001&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657ba001",
  null
  
)

export default component.exports